__turbopack_context__.v({
  "chevronRotated": "DonationsAggregateImpactTable-module-scss-module__BGBKMW__chevronRotated",
  "distribution": "DonationsAggregateImpactTable-module-scss-module__BGBKMW__distribution",
  "distributionHeader": "DonationsAggregateImpactTable-module-scss-module__BGBKMW__distributionHeader",
  "drift": "DonationsAggregateImpactTable-module-scss-module__BGBKMW__drift",
  "expandable": "DonationsAggregateImpactTable-module-scss-module__BGBKMW__expandable",
  "innertable": "DonationsAggregateImpactTable-module-scss-module__BGBKMW__innertable",
  "loaded": "DonationsAggregateImpactTable-module-scss-module__BGBKMW__loaded",
  "loadingSpinner": "DonationsAggregateImpactTable-module-scss-module__BGBKMW__loadingSpinner",
  "maintable": "DonationsAggregateImpactTable-module-scss-module__BGBKMW__maintable",
  "rowexpand": "DonationsAggregateImpactTable-module-scss-module__BGBKMW__rowexpand",
});
